import { c as _c } from "react/compiler-runtime";
import { getErrorMessage } from '@onefootprint/request';
import type { DashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { Table } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import Row, { MobileRow } from './row';
import useApiKeys from './use-api-keys';
const ApiKeysTable = () => {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("api-keys", t0);
  const {
    isPending,
    error,
    data
  } = useApiKeys();
  const isMobile = useMobileLayout();
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = [{
      text: t1,
      width: "100%"
    }];
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const mobileColumns = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isMobile || $[8] !== mobileColumns || $[9] !== t) {
    t4 = isMobile ? mobileColumns : [{
      text: t(_temp3),
      width: "15%"
    }, {
      text: t(_temp4),
      width: "25%"
    }, {
      text: t(_temp5),
      width: "15%"
    }, {
      text: t(_temp6),
      width: "15%"
    }, {
      text: t(_temp7),
      width: "12.5%"
    }, {
      text: t(_temp8),
      width: "12.5%"
    }, {
      text: "",
      width: "10%"
    }];
    $[7] = isMobile;
    $[8] = mobileColumns;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== error || $[12] !== t) {
    t5 = error ? getErrorMessage(error) : t(_temp9);
    $[11] = error;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== data) {
    t6 = data ?? [];
    $[14] = data;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isMobile) {
    t7 = t8 => {
      const {
        item
      } = t8;
      return isMobile ? <MobileRow apiKey={item} /> : <Row apiKey={item} />;
    };
    $[16] = isMobile;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== isMobile || $[19] !== isPending || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t8 = <Table aria-label={t3} columns={t4} emptyStateText={t5} getAriaLabelForRow={_temp10} getKeyForRow={_temp11} hideThead={isMobile} isLoading={isPending} items={t6} renderTr={t7} hasRowEmphasis={_temp12} />;
    $[18] = isMobile;
    $[19] = isPending;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
export default ApiKeysTable;
function _temp($) {
  return $.table.header.name;
}
function _temp2($_0) {
  return $_0.table.ariaLabel;
}
function _temp3($_1) {
  return $_1.table.header.name;
}
function _temp4($_2) {
  return $_2.table.header.secretKey;
}
function _temp5($_3) {
  return $_3.table.header.lastUsed;
}
function _temp6($_4) {
  return $_4.table.header.created;
}
function _temp7($_5) {
  return $_5.table.header.status;
}
function _temp8($_6) {
  return $_6.table.header.accessControl.title;
}
function _temp9($_7) {
  return $_7.table.emptyState;
}
function _temp10(apiKey) {
  return apiKey.name;
}
function _temp11(apiKey_0) {
  return apiKey_0.id;
}
function _temp12() {
  return true;
}